// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"1a0035ef","415":"a32c43e5","787":"cda612ba"}[chunkId] + ".chunk.js";
};